import React from "react";
import PageNavLink from "../Common/PageNavLink";

export default function ProjectLinks() {
  return (
    <div className=" d-flex justify-content-center">
      {[
        {
          label: "PROJECT ATTRIBUTES",
          href: "/create/project/wizard/attributes",
        },
        {
          label: "PROJECT BUILDER",
          href: "/create/project/builder",
        },
        {
          label: "PROJECT OVERVIEW",
          href: "/create/project/overview",
        },
      ].map((f) => (
        <PageNavLink
            key={f.href}
            Icon={null}
            label={f.label}
            href={f.href}
          />
      ))}
    </div>
  );
}
